export const backoffice =
  "https://services.fuvibrainhive.com/backoffice/api/v0/";

export const membership =
  "https://services.fuvibrainhive.com/membership/api/v0/";

export const AUTH_PATH = "authentication";
